export default __webpack_public_path__ + "static/media/esg-dataset-logo.9585940c.png";